import moment from 'moment';
import { rem } from 'polished';
import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';
import { SIcon } from './index';

export const Cell = styled.div`
  margin-right: 0;
  display: flex;
  justify-content: center;
  align-items: end;
  height: 100%;
  margin-bottom: ${rem(5)};
  ${({ theme }) => theme.media.sm`
    margin-right: ${rem(30)};
    margin-bottom: 0;
  `};
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: ${rem(10)} 0;
  margin-bottom: 0;
  height: ${({ selected }) => (selected ? 'auto' : '100%')};
  ${({ theme }) => theme.media.sm`
    flex-direction: row;
    margin: 0;
  `};
`;

const Name = styled.div`
  position: unset;
  margin-left: 0;
  text-align: center;
  font-size: ${rem(14)};
  margin-top: ${rem(2)};
  ${({ theme }) => theme.media.sm`
    position: absolute;
    margin-left: ${rem(30)};
  ${props => {
    if (props.dots) {
      return css`
        margin-left: ${rem(30)};
        border-left: ${rem(2)} dotted #333333;
        padding-left: ${rem(24)};
        margin: 0;
        margin-left: ${rem(9)};
        margin-top: ${rem(4)};
      `;
    }
  }}
  `};
`;

export const Gulicka = styled.div`
  width: ${rem(20)};
  height: ${rem(20)};
  border-radius: 50%;
  border: ${rem(2.5)} solid ${({ theme }) => theme.color.font.primary};
  margin-right: ${rem(10)};
`;

const Transfer = props => {
  const { date, selected, owner, type, stopName } = props;
  const dateMoment = moment.parseZone(date);
  return (
    <div>
      <Wrapper selected={selected}>
        <Cell>
          <Gulicka />
          <div>{dateMoment.format('D.M.YYYY')}</div>
        </Cell>
        <Cell>
          <div>
            <SIcon name="clock" />
          </div>
          <div>
            {dateMoment.format('HH:mm')} {type}
          </div>
        </Cell>
        <Cell>
          <div>
            <SIcon name="calendar" />
          </div>
          <div>{dateMoment.format('dddd')}</div>
        </Cell>
        <Cell>
          <div>{owner}</div>
        </Cell>
      </Wrapper>
      <div>{stopName && <Name dots={props.dots}>{stopName}</Name>}</div>
    </div>
  );
};

Transfer.propTypes = {
  date: PropTypes.string.isRequired,
  selected: PropTypes.bool,
  stopName: PropTypes.string,
  dots: PropTypes.bool,
  type: PropTypes.string,
};
Transfer.defaultProps = {
  selected: false,
  stopName: null,
  dots: false,
  type: null,
};

export default Transfer;



// WEBPACK FOOTER //
// ./src/components/TravelRow/transfer.js